// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3E_9T","modalForm":"UpgradeEpcsModal_modalForm__2AI9K","modalFooter":"UpgradeEpcsModal_modalFooter__2mW42"};